import { render, staticRenderFns } from "./IndexAprovacao.vue?vue&type=template&id=625a953e&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./IndexAprovacao.vue?vue&type=style&index=0&id=625a953e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625a953e",
  null
  
)

export default component.exports